// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import styles from './PlaceholderPage.module.css';

interface PlaceholderPageProps {
  title: string;
}

/**
 * Generic "not built yet" panel for any Admin Center nav item that doesn't
 * have a real screen. Mirrors Helios' own `Scaffold` pattern
 * (pages/shell-screens/Scaffold.tsx) without importing it directly — see
 * admin-center/README.md on why.
 */
export default function PlaceholderPage({ title }: PlaceholderPageProps) {
  return (
    <div className={styles.wrap}>
      <div className={styles.title}>{title}</div>
    </div>
  );
}
